package com.jingfangpai.syndrome.model

import com.jingfangpai.common.orm.mapping.SyndromeIndicationSignSymptom
import com.jingfangpai.common.orm.mapping.SyndromeIndicationSignSymptomCharacteristic
import com.jingfangpai.common.orm.mapping.enums.*
import com.jingfangpai.medicalRecord.model.MedicalRecordSignSymptomDto
import kotlinx.serialization.Serializable

@Serializable
class SyndromeIndicationSignSymptomDetail:SyndromeIndicationSignSymptom() {
    var signSymptomName:SignSymptomName?=null
    var signSymptomNameAlias:String?=null
    var characteristics:Set<SyndromeIndicationSignSymptomCharacteristicDetail> = setOf()
    var children:Array<SyndromeIndicationSignSymptomDetail> = arrayOf()
    var applicable:MutableSet<SignSymptomApplicable>? = null

    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other == null || this::class != other::class) return false
        if (!super.equals(other)) return false

        other as SyndromeIndicationSignSymptomDetail

        if (signSymptomName != other.signSymptomName) return false
        if (characteristics != other.characteristics) return false
        if (!children.contentEquals(other.children)) return false

        return true
    }

    override fun hashCode(): Int {
        var result = super.hashCode()
        result = 31 * result + (signSymptomName?.hashCode() ?: 0)
        result = 31 * result + characteristics.hashCode()
        result = 31 * result + children.contentHashCode()
        return result
    }

    fun getRuleSymbol():String{
        return when(rule){
            SyndromeIndicationSignSymptomRule.但见即是 -> "是"
            SyndromeIndicationSignSymptomRule.可见 -> "可"
            SyndromeIndicationSignSymptomRule.必见 -> "必"
            SyndromeIndicationSignSymptomRule.但见即非 -> "非"
            else -> ""
        }
    }

    fun getDisplayName(foundSignSymptomName:Array<SignSymptomName>):String{
       return if(SyndromeIndicationSignSymptomType.组合 == type) "${groupName?:""}${this.children.map { "${it.getDisplayName(foundSignSymptomName)}" }.toString()}" else ((if(signSymptomNameAlias.isNullOrBlank()) (signSymptomName?.name?:"") else "${signSymptomName?.name?:""}(${signSymptomNameAlias})")+".${getRuleSymbol()?:""}"+if(foundSignSymptomName.contains(signSymptomName)) "✓" else "☓")
    }

    fun match(inputSymptoms:Array<MedicalRecordSignSymptomDto>):SyndromeIndicationSignSymptomMatchResult{
        var matchResult = SyndromeIndicationSignSymptomMatchResult(false,0.0,"")

        val allExistingSymptoms = inputSymptoms.filter { MedicalRecordSignSymptomState.存在 == it.state }
        val allExistingSymptomNames = allExistingSymptoms.map{it.signSymptomName}
        if(SyndromeIndicationSignSymptomType.单项 == this.type){
            val matched = allExistingSymptomNames.contains(this.signSymptomName)
            matchResult = if(matched) SyndromeIndicationSignSymptomMatchResult(matched,100.0,"单项符合") else SyndromeIndicationSignSymptomMatchResult(matched,0.0,"单项未符合")
            //理由
        }else{
            //但见即非
            val findOneRejectAll = this.children.filter { SyndromeIndicationSignSymptomRule.但见即非 == it.rule && allExistingSymptomNames.contains(it.signSymptomName) }
            if(!findOneRejectAll.isEmpty()){
                matchResult = SyndromeIndicationSignSymptomMatchResult(false,0.0,"存在但见即非症状${findOneRejectAll.toString()}")
                //suggestionDto.description = "满足以下症状（但见即非）：${findOneRejectAll.toString()}"
            }else{
                //必见症状是否均见
                val mustBeFound = this.children.filter { SyndromeIndicationSignSymptomRule.必见 == it.rule }.map { it.signSymptomName }
                val actualFound =  allExistingSymptomNames.filter { mustBeFound.contains(it) }
                if(mustBeFound.size != actualFound.size){
                    matchResult = SyndromeIndicationSignSymptomMatchResult(false,0.0,"必见症状未满足，要求：${mustBeFound.toString()}，实际：${actualFound.toString()}") //
                }else{
                    val findOneMeansAll = this.children.filter { SyndromeIndicationSignSymptomRule.但见即是 == it.rule && allExistingSymptomNames.contains(it.signSymptomName) }
                    if(!findOneMeansAll.isEmpty()){
                        matchResult = SyndromeIndicationSignSymptomMatchResult(true,100.0,"满足以下症状（但见即是）：${findOneMeansAll.toString()}")
                    }else{
                        val allOptionalSymptom = this.children.filter { SyndromeIndicationSignSymptomRule.可见 == it.rule}
                        val allOptionalSymptomTotalScore = allOptionalSymptom.sumOf { it.score?:0 }*1.0
                        var optionalScoreSum = 0.0;
                        var matchedSymptoms = arrayOf<SignSymptomName>() //这里还存在组合问题
                        allOptionalSymptom.forEach { optionalSymptom ->
                            if(SyndromeIndicationSignSymptomType.单项 == optionalSymptom.type) {
                                if (optionalSymptom.signSymptomName != null && allExistingSymptomNames.contains(optionalSymptom.signSymptomName)) {
                                    optionalScoreSum += (optionalSymptom.score ?: 0) * 1.0
                                    matchedSymptoms += optionalSymptom.signSymptomName!!
                                }
                            }
                        }
                        val finalOptionScore = (optionalScoreSum/allOptionalSymptomTotalScore)*100.0
                        val optionalMatched = finalOptionScore>0
                        val finalMatched = mustBeFound.size>0 || (mustBeFound.size >= 0 && optionalMatched)
                        if(finalMatched){
                            matchResult = SyndromeIndicationSignSymptomMatchResult(true,100.0,if(mustBeFound.size>0) "满足必见症状${mustBeFound.toString()}，且满足以下可见症状：${findOneMeansAll.toString()}" else "满足以下可见症状：${findOneMeansAll.toString()}")
                        }else{
                            matchResult = SyndromeIndicationSignSymptomMatchResult(false,0.0,if(mustBeFound.size>0) "未满足必见症状${mustBeFound.toString()}" else "未满足任何症状")
                        }
                    }
                }
            }
        }
        return matchResult
    }

}